import { api } from 'config'

export const SUPPORT_URL = {
   getRequests: `${api.public}v1/support`,
   modifyRequest: `${api.public}v1/support`
}
